/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';

interface SegmentBannerArgs {
  showBanner: boolean;
  campaignId: string;
  conversionType: string;
  conversionSegmentName: string;
  disabled: boolean;
  onAddTriggerFilter: () => Promise<unknown>;
}

export default class SegmentBanner extends Component<SegmentBannerArgs> {
  @service router!: RouterService;
  @tracked isDismissed = false;
  @tracked showSuccessBanner = false;

  get triggerFilterTypeText() {
    return this.args.conversionType === 'enter' ? 'not in' : 'in';
  }

  get triggerFilterText() {
    return `${this.triggerFilterTypeText} ${this.args.conversionSegmentName}`;
  }

  @action
  onDismissBanner() {
    this.isDismissed = true;
  }

  @action
  onDismissSuccessBanner() {
    this.showSuccessBanner = false;
  }

  addTriggerFilterTask = task(async () => {
    await this.args.onAddTriggerFilter();
    this.showSuccessBanner = true;
  });
}
